// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_conf__Config from "../../../../../../../packages/conf/lib/Config.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Buhta_landing__ButtonPrimary from "../../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__Field from "../../../../components/landing/Field.js";
import * as Caml_array from "melange.js/caml_array.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Fetch from "melange-fetch/Fetch.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function JobForm(Props) {
  const match = React.useState(function () {
    return "";
  });
  const setName = match[1];
  const name = match[0];
  const match$1 = React.useState(function () {
    return "";
  });
  const setEmail = match$1[1];
  const email = match$1[0];
  const match$2 = React.useState(function () {
    return "";
  });
  const setPhone = match$2[1];
  const phone = match$2[0];
  const match$3 = React.useState(function () {
    return "";
  });
  const setCity = match$3[1];
  const city = match$3[0];
  const match$4 = React.useState(function () {
    return {
      hd: "",
      tl: /* [] */ 0
    };
  });
  const setSocialList = match$4[1];
  const socialList = match$4[0];
  const match$5 = React.useState(function () {
    return {};
  });
  const setResume = match$5[1];
  const resume = match$5[0];
  const match$6 = React.useState(function () {
    return false;
  });
  const setLoading = match$6[1];
  const loading = match$6[0];
  const match$7 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$7[1];
  const submit = function (ev) {
    const cfg = Buhta_conf__Config.getConfig(undefined);
    const social = Belt__Belt_List.toArray(socialList);
    Curry._1(setLoading, (function (param) {
      return true;
    }));
    const formData = new FormData();
    formData.append("files.resume", resume, undefined);
    formData.append("data", JSON.stringify(Js__Js_dict.fromList({
      hd: [
        "name",
        name
      ],
      tl: {
        hd: [
          "email",
          email
        ],
        tl: {
          hd: [
            "phone",
            phone
          ],
          tl: {
            hd: [
              "city",
              city
            ],
            tl: {
              hd: [
                "social",
                social
              ],
              tl: /* [] */ 0
            }
          }
        }
      }
    })));
    fetch(cfg.cms_api_url + "/requests", Fetch.RequestInit.make(/* Post */ 2, undefined, Caml_option.some(formData), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(undefined)).then(function (res) {
      if (res.ok) {
        Curry._1(dispatchToasts, {
          TAG: /* Add */ 0,
          _0: {
            id: Buhta_core__Toast.generateId(undefined),
            text: "Заявка успешно доставлена",
            kind: "success",
            onClick: (function (param) {
              
            })
          }
        });
        Curry._1(setEmail, (function (param) {
          return "";
        }));
        Curry._1(setPhone, (function (param) {
          return "";
        }));
        Curry._1(setName, (function (param) {
          return "";
        }));
        Curry._1(setCity, (function (param) {
          return "";
        }));
        Curry._1(setSocialList, (function (param) {
          return {
            hd: "",
            tl: /* [] */ 0
          };
        }));
        Curry._1(setResume, (function (param) {
          return {};
        }));
      } else {
        Curry._1(dispatchToasts, {
          TAG: /* Add */ 0,
          _0: {
            id: Buhta_core__Toast.generateId(undefined),
            text: "Произошла ошибка. Попробуйте еще раз.",
            kind: "warning",
            onClick: (function (param) {
              
            })
          }
        });
      }
      Curry._1(setLoading, (function (param) {
        return false;
      }));
      return Promise.resolve(res);
    }).catch(function (param) {
      Curry._1(dispatchToasts, {
        TAG: /* Add */ 0,
        _0: {
          id: Buhta_core__Toast.generateId(undefined),
          text: "Произошла ошибка.",
          kind: "warning",
          onClick: (function (param) {
            
          })
        }
      });
      Curry._1(setLoading, (function (param) {
        return false;
      }));
      return Promise.resolve(error());
    });
    ev.preventDefault();
  };
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsx(Buhta_landing__Field.make, {
        label: "Фамилия и Имя",
        name: "name",
        value: name,
        onChange: (function (value) {
          Curry._1(setName, (function (param) {
            return value;
          }));
        }),
        className: "h-14 border-b border-divider pb-2 mt-2 first:mt-0",
        required: true,
        color: "text-gray-light-landing",
        topActive: "top-2",
        topPassive: "top-6",
        disabled: loading
      }),
      JsxRuntime.jsx(Buhta_landing__Field.make, {
        label: "Город проживания",
        name: "city",
        value: city,
        onChange: (function (value) {
          Curry._1(setCity, (function (param) {
            return value;
          }));
        }),
        className: "h-14 border-b border-divider pb-2 mt-2 first:mt-0",
        required: true,
        color: "text-gray-light-landing",
        topActive: "top-2",
        topPassive: "top-6",
        disabled: loading
      }),
      JsxRuntime.jsx(Buhta_landing__Field.make, {
        label: "Email",
        type_: "email",
        name: "email",
        value: email,
        onChange: (function (value) {
          Curry._1(setEmail, (function (param) {
            return value;
          }));
        }),
        className: "h-14 border-b border-divider pb-2 mt-2 first:mt-0",
        required: true,
        color: "text-gray-light-landing",
        topActive: "top-2",
        topPassive: "top-6",
        disabled: loading
      }),
      JsxRuntime.jsx(Buhta_landing__Field.make, {
        label: "Номер телефона",
        name: "phone",
        value: phone,
        onChange: (function (value) {
          Curry._1(setPhone, (function (param) {
            return value;
          }));
        }),
        className: "h-14 border-b border-divider pb-2 mt-2 first:mt-0",
        required: true,
        color: "text-gray-light-landing",
        topActive: "top-2",
        topPassive: "top-6",
        disabled: loading
      }),
      Belt__Belt_List.toArray(Stdlib__List.mapi((function (idx, s) {
        const Key = String(idx);
        return JsxRuntime.jsx(Buhta_landing__Field.make, {
          label: "Ссылка на профиль в соцсетях",
          name: "social",
          value: s,
          onChange: (function (value) {
            Curry._1(setSocialList, (function (state) {
              return Stdlib__List.mapi((function (i, v) {
                if (i === idx) {
                  return value;
                } else {
                  return v;
                }
              }), state);
            }));
          }),
          className: "h-14 border-b border-divider pb-2 mt-2 first:mt-0",
          color: "text-gray-light-landing",
          topActive: "top-2",
          topPassive: "top-6",
          disabled: loading
        }, Key);
      }), socialList)),
      JsxRuntime.jsxs("p", {
        children: [
          JsxRuntime.jsx("img", {
            className: "inline mr-1",
            src: StaticAsset.src("/static/icons/plus-blue.svg")
          }),
          "Еще одна ссылка"
        ],
        className: "paragraph text-primary mt-2 cursor-pointer",
        onClick: (function (param) {
          Curry._1(setSocialList, (function (state) {
            return Stdlib.$at(state, {
              hd: "",
              tl: /* [] */ 0
            });
          }));
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          Caml_obj.caml_equal(resume, {}) ? "Выбрать резюме/портфолио" : "Файл выбран",
          JsxRuntime.jsx("input", {
            className: "opacity-0 absolute left-0 top-0 w-full bottom-0 cursor-pointer",
            name: "resume",
            required: true,
            type: "file",
            onChange: (function (ev) {
              const file = Caml_array.get(ev.target.files, 0);
              Curry._1(setResume, (function (param) {
                return file;
              }));
            })
          })
        ],
        className: "paragraph-medium text-center text-primary mt-6 lg:mt-10 rounded-lg p-3.5 relative border border-dashed border-primary"
      }),
      JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
        classes: {
          hd: "mt-6 lg:mt-10 w-full",
          tl: /* [] */ 0
        },
        label: "Отправить",
        type_: "submit",
        isDisabled: loading
      })
    ],
    className: "bg-bg rounded-lg mt-6 lg:mt-10 p-6 lg:p-10",
    onSubmit: submit
  });
}

const make = JobForm;

export {
  make,
}
/* Buhta_conf__Config Not a pure module */
